var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { styled } from 'styled-components';
import { SkillStatus } from '../../../constants/statuses';
var ScButton = styled.button.withConfig({ displayName: "ScButton", componentId: "sc-1e6md6s" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: transparent;\n  border: none;\n  padding: 0;\n  width: 100%;\n  cursor: pointer;\n  z-index: 1;\n\n  &[data-disabled='true'] {\n    cursor: not-allowed !important;\n  }\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: transparent;\n  border: none;\n  padding: 0;\n  width: 100%;\n  cursor: pointer;\n  z-index: 1;\n\n  &[data-disabled='true'] {\n    cursor: not-allowed !important;\n  }\n"])));
export var ExpandRowButton = function (_a) {
    var _b;
    var row = _a.row, onClick = _a.onClick;
    var original = row.original;
    var props = row.getToggleRowExpandedProps({ title: undefined });
    var isDisabled = (_b = original === null || original === void 0 ? void 0 : original.skills) === null || _b === void 0 ? void 0 : _b.every(function (el) { return el.status === SkillStatus.NoData; });
    var onExpandClick = React.useCallback(function () {
        var _a;
        if (isDisabled)
            return;
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props);
        onClick === null || onClick === void 0 ? void 0 : onClick();
    }, [isDisabled, onClick, props]);
    return (_jsx(ScButton, __assign({}, props, { "data-disabled": isDisabled, onClick: onExpandClick }), void 0));
};
var templateObject_1;
